<nz-select
    [nzPlaceHolder]="placeholder"
    nzAllowClear
    nzShowSearch
    nzServerSearch
    [nzBorderless]="borderless"
    [nzMode]="multi ? 'multiple' : 'default'"
    [nzDisabled]="disabled"
    [(ngModel)]="val"
    (nzOnSearch)="onSearch($event)"
    (ngModelChange)="onchange($event)"
    [ngClass]="{ highlight: borderless, wide: wide, expanded: expanded }"
    [nzDropdownMatchSelectWidth]="false"
>
    <ng-container *ngIf="!loading; else loadingTpl">
        <nz-option
            *ngFor="let lookup of lookups"
            nzCustomContent
            [nzLabel]="
                lookup.label +
                '\n' +
                (lookup.description || '') +
                '\n' +
                (lookup.tag || '')
            "
            [nzValue]="lookup._id"
            [nzHide]="hiddenOptions[lookup._id]"
        >
            <div class="option-header">
                <div>{{ lookup.label }}</div>
                <nz-tag
                    *ngIf="type === 'products' && productTags"
                    class="subscription-tag"
                    [nzColor]="lookup.isSubscription ? 'green' : 'blue'"
                >
                    {{ lookup.isSubscription ? 'Subscription' : 'One Time' }}
                </nz-tag>
            </div>
            <div
                *ngIf="type === 'products' && lookup.subLabel"
                style="color: gray; font-size: 12px"
            >
                {{ lookup.subLabel }}
            </div>
            <nz-tag *ngIf="lookup.tag" style="font-size: 9px; border: none">{{
                lookup.tag
            }}</nz-tag>
            <small style="color: gray" *ngIf="lookup.description">{{
                lookup.description
            }}</small>
        </nz-option>
    </ng-container>
    <ng-template #loadingTpl>
        <nz-option nzDisabled nzCustomContent>
            <i
                style="margin-right: 5px"
                nz-icon
                nzType="loading"
                class="loading-icon"
            ></i>
            Loading...
        </nz-option>
    </ng-template>
</nz-select>
<i *ngIf="multi" class="fas fa-chevron-down"></i>
